/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { IReferenceNode } from '../../../core/models/IReferenceNode';
import { OasHeader } from '../../models/OasHeader';

/**
 * Constructor.
 * @param {string} name
 * @class
 * @extends OasHeader
 * @author eric.wittmann@gmail.com
 */
export class Oas30Header extends OasHeader implements IReferenceNode {
    public $ref : string;

    public required : boolean;

    public deprecated : boolean;

    public allowEmptyValue : boolean;

    public style : string;

    public explode : boolean;

    public allowReserved : boolean;

    public schema : Oas30Schema;

    public example : any;

    public examples : any;

    public content : any;

    public constructor(name : string) {
        super(name);
        if(this.$ref===undefined) this.$ref = null;
        if(this.required===undefined) this.required = null;
        if(this.deprecated===undefined) this.deprecated = null;
        if(this.allowEmptyValue===undefined) this.allowEmptyValue = null;
        if(this.style===undefined) this.style = null;
        if(this.explode===undefined) this.explode = null;
        if(this.allowReserved===undefined) this.allowReserved = null;
        if(this.schema===undefined) this.schema = null;
        if(this.example===undefined) this.example = null;
        this.examples = <any>({});
        this.content = <any>({});
    }

    /**
     * 
     * @return {string}
     */
    public getReference() : string {
        return this.$ref;
    }

    /**
     * 
     * @param {string} reference
     */
    public setReference(reference : string) {
        this.$ref = reference;
    }

    /**
     * Creates a child items model.
     * @return {Oas30Schema}
     */
    public createSchema() : Oas30Schema {
        let rval : Oas30Schema = new Oas30Schema();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * Creates a child Example model.
     * @param {string} name
     * @return {Oas30Example}
     */
    public createExample(name : string) : Oas30Example {
        let rval : Oas30Example = new Oas30Example(name);
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * Adds the Example to the map of examples.
     * @param {Oas30Example} example
     */
    public addExample(example : Oas30Example) {
        /* put */(this.examples[example.getName()] = example);
    }

    /**
     * Removes an Example and returns it.
     * @param {string} name
     * @return {Oas30Example}
     */
    public removeExample(name : string) : Oas30Example {
        return /* remove */(map => { let deleted = this.examples[name];delete this.examples[name];return deleted;})(this.examples);
    }

    /**
     * Gets a single example by name.
     * @param {string} name
     * @return {Oas30Example}
     */
    public getExample(name : string) : Oas30Example {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.examples, name);
    }

    /**
     * Gets all examples.
     * @return {Oas30Example[]}
     */
    public getExamples() : Array<Oas30Example> {
        let rval : Array<Oas30Example> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.examples));
        return rval;
    }

    /**
     * Creates a media type.
     * @param {string} name
     * @return {Oas30MediaType}
     */
    public createMediaType(name : string) : Oas30MediaType {
        let rval : Oas30MediaType = new Oas30MediaType(name);
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * Adds a media type.
     * @param {string} name
     * @param {Oas30MediaType} mediaType
     */
    public addMediaType(name : string, mediaType : Oas30MediaType) {
        /* put */(this.content[name] = mediaType);
    }

    /**
     * Gets a single media type by name.
     * @param {string} name
     * @return {Oas30MediaType}
     */
    public getMediaType(name : string) : Oas30MediaType {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.content, name);
    }

    /**
     * Removes a single media type and returns it.  This may return null or undefined if none found.
     * @param {string} name
     * @return {Oas30MediaType}
     */
    public removeMediaType(name : string) : Oas30MediaType {
        return /* remove */(map => { let deleted = this.content[name];delete this.content[name];return deleted;})(this.content);
    }

    /**
     * Gets a list of all media types.
     * @return {Oas30MediaType[]}
     */
    public getMediaTypes() : Array<Oas30MediaType> {
        let rval : Array<Oas30MediaType> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.content));
        return rval;
    }
}
Oas30Header["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Header";
Oas30Header["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.INamed"];





import { Oas30MediaType } from './Oas30MediaType';


import { Oas30Example } from './Oas30Example';


import { Oas30Schema } from './Oas30Schema';

